import React from 'react'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'

const UserNotFound = () => (
  <section>
    <header>
      <PageTitle>
        User not found!
      </PageTitle>
    </header>
    <br/>
    <BackButton/>
  </section>
)

export default UserNotFound



// WEBPACK FOOTER //
// ./src/components/Users/UserNotFound.jsx